<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-list me-2"></i>{{ TR.posts }}
        </div>

        <div class="card-body">
            <DADataTableLazy
                v-if="tableOptions"
                ref="post_table_ref"
                :tableOptions="tableOptions"
                :lazyUrl="lazyUrl"
                :lazyParam="lazyParam"
            />
        </div>
    </div>
</template>


<script>
    import { onBeforeMount, ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";
    // import moment from 'moment-timezone';

    import { G, ajax } from "@/_common";
    import DADataTableLazy from "@/components/table/DADataTableLazy";

    export default {
        title: "posts",
        name: 'PostP',
        components: {
            DADataTableLazy,
        },
        setup() {
            const store = useStore();

            // const tableData = ref([]);
            const tableOptions = ref();
            // const filter_groups = ref([]);
            const categories = ref([]);
            const authors = ref([]);
            const post_table_ref = ref();
            const TR = ref({});

            const lazyUrl = ref(store.getPostLazy());
            const lazyParam = ref(store.getDataTableParams());

            onBeforeMount(async () => {
                // await ajax({
                //     url: store.getFilterList(),
                //     success: (e) => {
                //         const res = e.data || null;
                //         if (res) {
                //             filter_groups.value = res.map((a) => {
                //                 return { value: a.id, label: a.translate[0].name };
                //             });
                //         }
                //     }
                // });

                await ajax({
                    url: store.getCategoryList(),
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            categories.value = [];
                            categories.value = res.map((e) => {
                                return { value: e.id, label: e.translate[0].name, icon: `<img src="${e.image}" class="rounded me-1" style="width: 20px; height: 20px;" />` };
                            });
                        }
                    }
                });

                await ajax({
                    url: store.getAuthorList(),
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            authors.value = [];
                            authors.value = res.map((e) => {
                                return { value: e.id, label: `${e.translate[0].firstname} ${e.translate[0].lastname}`, icon: `<img src="${e.image}" class="rounded me-1" style="width: 20px; height: 20px;" />` };
                            });
                        }
                    }
                });

            });


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    // row_total: false,
                    // row_per_page: 5,

                    header_buttons: [
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: "fas fa-plus me-1",
                            class: "btn-primary",
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    // subTitle: `<span class="text-danger1">${TR.value.name}</span>`,
                                    modal_width: 80,
                                    page: "components/table/DynamicTable2",
                                    data: {
                                        permission_method: 'add'
                                    },
                                    table_columns_forlang: [
                                        {
                                            name: "title",
                                            title: TR.value.title,
                                            field_type: "text",
                                            required: true,
                                        },
                                        {
                                            name: "short",
                                            title: TR.value.short,
                                            field_type: "textarea",
                                        },
                                        {
                                            name: "content",
                                            title: TR.value.content,
                                            field_type: "editor",
                                            height: 300,
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            // value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            // fileSelectMode: 'advanced',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        // {
                                        //     name: "name",
                                        //     title: TR.value.name,
                                        //     field_type: "text",
                                        //     required: true,
                                        // },
                                        // {
                                        //     name: "code",
                                        //     title: TR.value.code,
                                        //     field_type: 'text',
                                        // },
                                        {
                                            name: "category_id",
                                            title: TR.value.category,
                                            field_type: 'dropdown',
                                            dropdown_items: categories.value,
                                            dropdown_item_selected: categories.value[0]?.value,
                                        },
                                        {
                                            private: G.privateIfNotAdmin(),
                                            name: "author_id",
                                            title: TR.value.author,
                                            field_type: 'dropdown',
                                            dropdown_items: authors.value,
                                            dropdown_item_selected: authors.value[0]?.value,
                                        },
                                        // {
                                        //     name: "filter_groups",
                                        //     title: TR.value.filter,
                                        //     field_type: "multiselect",
                                        //     dropdown_items: filter_groups.value,
                                        //     dropdown_item_selected: [],
                                        //     // onChange: (e, s) => {
                                        //     //     console.log(s, e);
                                        //     //     (document.getElementById('EventTypeSelection')
                                        //     //         .getElementsByClassName('ui-multiselect-label-container')[0]
                                        //     //         .getElementsByClassName('ui-multiselect-label')[0]).textContent = this.SelectedEventTypes.length + ' ausgewählt';
                                        //     // }
                                        // },
                                        // {
                                        //     name: "rank",
                                        //     title: TR.value.rank,
                                        //     value: () => 1,
                                        //     field_type: 'integer',
                                        //     max: 10000,
                                        //     // default: 1
                                        // },
                                        {
                                            name: "main_status",
                                            title: TR.value.main_status,
                                            value: () => false,
                                            field_type: "switch",
                                            grouping: false,
                                        },
                                        {
                                            name: "publish",
                                            title: TR.value.publish,
                                            value: () => false,
                                            field_type: "switch",
                                            grouping: false,
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                            grouping: false,
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.title[1] != '' ){
                                                            let formData = new FormData();

                                                            let post_data = {
                                                                "category_id": e.category_id,
                                                                "author_id": e.author_id,
                                                                "main_status": e.main_status,
                                                                "publish": e.publish,
                                                                "status": e.status,
                                                                // "filter_groups": e.filter_groups,
                                                                // "post_images": [{"image": e.image.name}],
                                                                "translate": G.lang_list.map((a) => ({
                                                                    "lang_id": a.value,
                                                                    "title": e.title[a.value] || e.title[1],
                                                                    "short": e.short[a.value] || e.short[1],
                                                                    "content": e.content[a.value] || e.content[1],
                                                                })),
                                                            };

                                                            if( e.image != null && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }
                                                            if( e.image != null && typeof e.image !== 'object' )
                                                                post_data.image = e.image;

                                                            formData.append("data", JSON.stringify(post_data));

                                                            await ajax({
                                                                url: store.getPost(),
                                                                method: 'post',
                                                                data: formData,
                                                                content_type: 'multipart/form-data',
                                                                success: (x) => {
                                                                    let res1 = x.data || null;
                                                                    if ( x.status == 200 && res1) {
                                                                        // res.create_date = new Date(res.create_date);
                                                                        // post.value.push({ value: res.id, label: res.translate[0].name });
                                                                        // post_table_ref.value.tableData.unshift(res1);
                                                                        post_table_ref.value.loadLazyData();
                                                                        G.alert.success({msg: TR.value.msg_add_success});
                                                                        G.closeModal(res);
                                                                    }
                                                                    else
                                                                        G.alert.error({msg: res1.detail});
                                                                },
                                                                // error: (x) => {
                                                                //     var res = x.response || {};
                                                                //     if( res.status && res.status == 422 ){
                                                                //         G.alert.error({title: TR.value.warning, msg: G.getErrorMessages(res.data.detail)});
                                                                //     }
                                                                //     else
                                                                //         G.alert.error({msg: TR.value.msg_add_failed});
                                                                // }
                                                            });
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_name});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                // toast.removeAllGroups()
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getPostUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            let res = e.data || null;
                                            if ( e.status == 200 && res){
                                                post_table_ref.value.loadLazyData();
                                                // tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                                // post.value.filter((x, i) => { if (x.value === data.id) post.value.splice(i, 1); } );
                                                G.alert.success(res.detail);
                                            }
                                            else
                                                G.alert.error(res.detail);
                                        },
                                        // error: (e) => {
                                        //     let res = e.response || null;
                                        //     if( res.status && res.status == 422 ){
                                        //         G.alert.warning(G.getErrorMessages(res.data.detail));
                                        //     }
                                        //     else
                                        //         G.alert.error(TR.value.msg_remove_failed);
                                        // }
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            label: "",
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: async (data) => {
                                data.permission_method = 'update';

                                await ajax({
                                    loading: true,
                                    url: store.getPostUpdate(data.id),
                                    success: (e) => {
                                        let res = e.data || null;
                                        if (res) {
                                            data.translate = res.translate;
                                        }
                                    }
                                });

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: `${data.translate[0].title}`,
                                    dismiss: false,
                                    modal_width: 80,
                                    page: "components/table/DynamicTable2",
                                    data: data,
                                    table_columns_forlang: [
                                        {
                                            name: "title",
                                            value: (l) => l.title,
                                            title: TR.value.title,
                                            field_type: 'text',
                                            required: true,
                                        },
                                        {
                                            name: "short",
                                            title: TR.value.short,
                                            value: (l) => l.short,
                                            field_type: "textarea",
                                        },
                                        {
                                            name: "content",
                                            title: TR.value.content,
                                            value: (l) => l.content,
                                            field_type: "editor",
                                            height: 300,
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            value: "image",
                                            // value: (e) => e..image : '',
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            // value: (e) => e.post_images?.length ? e.post_images[0].image : '',
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        // {
                                        //     name: "name",
                                        //     value: (e) => e.translate[0].name,
                                        //     title: TR.value.name,
                                        //     field_type: 'text',
                                        //     required: true,
                                        // },
                                        // {
                                        //     name: "code",
                                        //     value: "code",
                                        //     title: TR.value.code,
                                        //     field_type: 'text',
                                        // },
                                        {
                                            name: "category_id",
                                            value: "category_id",
                                            title: TR.value.category,
                                            // field_type: 'text',
                                            field_type: 'dropdown',
                                            dropdown_items: categories.value, //.filter(e => e.value !== data.id),
                                            dropdown_item_selected: data.category_id
                                        },
                                        {
                                            name: "author_id",
                                            value: "author_id",
                                            title: TR.value.author,
                                            // field_type: 'text',
                                            field_type: 'dropdown',
                                            dropdown_items: authors.value, //.filter(e => e.value !== data.id),
                                            dropdown_item_selected: data.author_id
                                        },
                                        // {
                                        //     name: "filter_groups",
                                        //     title: TR.value.filter,
                                        //     field_type: "multiselect",
                                        //     dropdown_items: filter_groups.value,
                                        //     // dropdown_item_selected: [filter_groups.value[0].value],
                                        //     dropdown_item_selected: data.filter_group_rel?.map(c => c.filter_group_id),
                                        //     // onChange: (e, s) => {
                                        //     //     console.log(s, e);
                                        //     //     (document.getElementById('EventTypeSelection')
                                        //     //         .getElementsByClassName('ui-multiselect-label-container')[0]
                                        //     //         .getElementsByClassName('ui-multiselect-label')[0]).textContent = this.SelectedEventTypes.length + ' ausgewählt';
                                        //     // }
                                        // },
                                        // {
                                        //     name: "rank",
                                        //     value: "rank",
                                        //     title: TR.value.rank,
                                        //     field_type: 'integer',
                                        //     max: 10000,
                                        // },
                                        {
                                            name: "main_status",
                                            title: TR.value.main_status,
                                            value: (e) => e.main_status == 1 ? true : false,
                                            field_type: "switch",
                                            grouping: false,
                                        },
                                        {
                                            name: "publish",
                                            title: TR.value.publish,
                                            value: (e) => e.publish == 1 ? true : false,
                                            field_type: "switch",
                                            grouping: false,
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status == 1 ? true : false,
                                            field_type: "switch",
                                            grouping: false,
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if(e && e.title[1] != ''){
                                                            let formData = new FormData();

                                                            // if( e.images.length ){
                                                            //     Array.from(e.images).forEach(file => {
                                                            //         if( file instanceof Object ){
                                                            //             formData.append('upload_image', file);
                                                            //         }
                                                            //     });
                                                            // }
                                                            let post_data = {
                                                                "category_id": e.category_id,
                                                                "author_id": e.author_id,
                                                                "main_status": e.main_status,
                                                                "publish": e.publish,
                                                                "status": e.status,
                                                                // "filter_groups": e.filter_groups,
                                                                "translate": G.lang_list.map((a) => (
                                                                    {
                                                                        "lang_id": a.value,
                                                                        "title": e.title[a.value] || e.title[1],
                                                                        "short": e.short[a.value] || e.short[1],
                                                                        "content": e.content[a.value] || e.content[1],
                                                                    }
                                                                )),
                                                            };

                                                            if( e.image != null && e.image != data.image && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }
                                                            if( e.image != data.image && typeof e.image !== 'object' )
                                                                post_data.image = e.image;

                                                            formData.append("data", JSON.stringify(post_data));

                                                            await ajax({
                                                                loading: true,
                                                                url: store.getPostUpdate(data.id),
                                                                method: 'patch',
                                                                data: formData,
                                                                content_type: 'multipart/form-data',
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if (res) {
                                                                        // res.create_date = new Date(res.create_date);
                                                                        // tableData.value.forEach(
                                                                        //     (s) => { if ( s.id === res.id ) { s = res; } }
                                                                        // );
                                                                        // for (let a in res) {
                                                                        //     post_table_ref.value.tableData[a] = res[a];
                                                                        // }
                                                                        post_table_ref.value.loadLazyData();
                                                                        // post.value.forEach( c => {
                                                                        //     if(c.value == res.id) {
                                                                        //         c.value = res.id;
                                                                        //         c.label = res.translate[0].name;
                                                                        //     }
                                                                        // });
                                                                        G.alert.success(TR.value.msg_update_success);
                                                                    }
                                                                },
                                                                // error: (x) => {
                                                                //     var res = x.response || {};
                                                                //     if( res.status == 422 ){
                                                                //         G.alert.warning(G.getErrorMessages(res.data.detail));
                                                                //     }
                                                                //     else
                                                                //         G.alert.error(res.data.detail);
                                                                // }
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_name});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            name: 'status',
                            title: TR.value.status,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getPostActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: () => {
                                        // let res = a.data;
                                        post_table_ref.value.loadLazyData();
                                        G.alert.success({toast: true, msg: TR.value.msg_success});
                                        // res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                                        // tableData.value.forEach(
                                        //     (s) => { if ( s.id === res.id ) { s = res; } }
                                        // );
                                        // for (let a in res) {
                                        //     data[a] = res[a];
                                        // }
                                    }
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        // {
                        //     name: 'status',
                        //     title: TR.value.status,
                        //     value: (e) => e.status == 0 ? false : true,
                        //     class: 'text-center',
                        //     element: 'switch',
                        //     eventName: 'change',
                        //     eventCallback: async (data, event) => {
                        //         await ajax({
                        //             url: store.getPostActivate(data.id, event.target.checked ? 1 : 0),
                        //             method: 'post',
                        //             success: (a) => {
                        //                 let res = a.data;
                        //                 G.alert.success({msg: TR.value.msg_update_success});
                        //                 res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                        //                 tableData.value.forEach(
                        //                     (s) => { if ( s.id === res.id ) { s = res; } }
                        //                 );
                        //                 for (let a in res) {
                        //                     data[a] = res[a];
                        //                 }
                        //             }
                        //         });
                        //     },
                        //     // elementClass: 'bg-danger',
                        //     // attr: 'disabled',
                        //     // attrValue: true,
                        //     filter: false,
                        //     sortable: false,
                        //     exportable: false,
                        // },
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                            visible: false,
                        },
                        {
                            name: "image",
                            value: (e) => `<img src="${
                                                        e.image
                                                            ? e.image
                                                            : "/assets/img/noimg.png"
                                                    }"
                                                    class="border img-circle-cover"
                                                />`,
                            title: TR.value.image,
                            exportable: false,
                            sortable: false,
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "post_lang.title",
                            value: (e) => e.translate[0].title,
                            title: TR.value.title,
                        },
                        // {
                        //     name: "category_id",
                        //     value: (e) => e.category?.name,
                        //     title: TR.value.category,
                        // },
                        {
                            name: "author_lang.firstname",
                            value: (e) => e.author?.translate[0].firstname,
                            title: TR.value.author + 'in ' + TR.value.name,
                            sortable: false,
                            filter_field: "author_lang.firstname",
                        },
                        {
                            name: "author_lang.lastname",
                            value: (e) => e.author?.translate[0].lastname,
                            title: TR.value.lastname,
                            sortable: false,
                            filter_field: "author_lang.lastname",
                        },
                        {
                            name: "category_id",
                            value: (e) => e.category ? `<div class="text-wrap badge bg-info text-light">${e.category.translate[0].name}</div>` : "",
                            title: TR.value.category,
                            body_style: "width: 60px;",
                            body_class: "text-wrap",
                            filters: {
                                operator: "or",
                                constraints: [
                                    { value: null, matchMode: 'in' },
                                ],
                            },
                            field_type: "grouping",
                            filter_field: "category_id",
                            filter_mode: "multidropdown",
                            filter: true,
                            dropdown_items: categories.value,
                        },

                        // {
                        //     name: "filter",
                        //     value: (e) => e.filter_group_rel?.length > 0 ? '<i class="fas fa-check text-success" />' : '<i class="fas fa-square border text-white" />',
                        //     title: TR.value.filter_group,
                        //     class: 'text-center',
                        //     sortable: false,
                        //     filter: false
                        // },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            date_format: 'dd.mm.yy',
                            field_type: "date",
                            filter_mode: "datetime",
                        },
                        {
                            name: 'main_status',
                            title: TR.value.main_status,
                            value: (e) => e.main_status == 1 ? true : false,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getPostMainActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data || undefined;
                                        if ( a.status == 200 && res) {
                                            for (let a in res) {
                                                data[a] = res[a];
                                            }
                                            G.alert.success({toast: true, msg: TR.value.msg_update_success});
                                        }
                                        else{
                                            G.alert.error(res.detail);
                                        }
                                    }
                                });
                            },
                            filter: false,
                            sortable: true,
                            exportable: true,
                        },
                        {
                            name: 'publish',
                            title: TR.value.publish,
                            value: (e) => e.publish == 1 ? true : false,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getPostPublishActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data || undefined;
                                        if ( a.status == 200 && res) {
                                            for (let a in res) {
                                                data[a] = res[a];
                                            }
                                            G.alert.success({toast: true, msg: TR.value.msg_update_success});
                                        }
                                        else{
                                            G.alert.error(res.detail);
                                        }
                                    }
                                });
                            },
                            filter: false,
                            sortable: true,
                            exportable: true,
                        },
                    ],
                };
            });

            return {
                TR,
                post_table_ref,
                // tableData,
                tableOptions,
                lazyUrl,
                lazyParam,
            };
        },
    };
</script>

